import React from 'react';
import BorrowerMailboxSC from './borrower-mailbox.styled';
import InfoBanner from '../../../components/info-banner';
import ContentWrap from '../../../components/content-wrap';
import BorrowerMailboxBanner from '../../../components/borrower-mailbox-banner';
import BorrowerMailboxContent from '../../../components/borrower-mailbox-content';

const BorrowerMailbox = () => {
  return (
    <BorrowerMailboxSC>
      <InfoBanner>
        <BorrowerMailboxBanner />
      </InfoBanner>
      <ContentWrap>
        <BorrowerMailboxContent />
      </ContentWrap>
    </BorrowerMailboxSC>
  );
};

export default BorrowerMailbox;
